import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

async function parseRoleAdminResponse(response) {
  const data = await response.json().catch(() => ({}));

  return {
    success: response.ok && data?.success === true,
    message: data?.message ?? "",
    code: data?.code ?? "",
    data: data?.data ?? null,
  };
}

export async function getRoleAdminDashboard() {
  try {
    const response = await authFetch(`${BACKEND_URL}/admin/role/dashboard`, {
      method: "GET",
    });

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[getRoleAdminDashboard] failed:", error);
    return {
      success: false,
      message: "관리자 대시보드 조회 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function getRoleAdminAccounts() {
  try {
    const response = await authFetch(`${BACKEND_URL}/admin/role/accounts`, {
      method: "GET",
    });

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[getRoleAdminAccounts] failed:", error);
    return {
      success: false,
      message: "생성 계정 목록 조회 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function updateRoleAdminAccountPermission(id, payload) {
  const body =
    payload && typeof payload === "object" && "permission" in payload
      ? payload
      : { permission: payload };

  try {
    const response = await authFetch(
      `${BACKEND_URL}/admin/role/accounts/${id}/permission`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    );

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[updateRoleAdminAccountPermission] failed:", error);
    return {
      success: false,
      message: "계정 권한 저장 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function getManagerCreationRequests({ status = "pending" } = {}) {
  try {
    const params = new URLSearchParams({ status });
    const response = await authFetch(
      `${BACKEND_URL}/admin/manager-creation-requests?${params.toString()}`,
      {
        method: "GET",
      },
    );

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[getManagerCreationRequests] failed:", error);
    return {
      success: false,
      message: "매니저 생성 요청 목록 조회 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function approveManagerCreationRequest(id) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/admin/manager-creation-requests/${id}/approve`,
      {
        method: "POST",
      },
    );

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[approveManagerCreationRequest] failed:", error);
    return {
      success: false,
      message: "매니저 생성 승인 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function rejectManagerCreationRequest(id) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/admin/manager-creation-requests/${id}/reject`,
      {
        method: "POST",
      },
    );

    return parseRoleAdminResponse(response);
  } catch (error) {
    console.error("[rejectManagerCreationRequest] failed:", error);
    return {
      success: false,
      message: "매니저 생성 거절 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}
